// CareLogix™ ORACLE — OANDA FX Trading Screen API Client (Phase 22).
// Strictly additive — does not alter any prior client.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/oracle/fx`;

const TOKEN_LS = "carelogix_oracle_token";
const UID_LS = "carelogix_oracle_user_id";
function headers() {
  const h = {};
  try {
    const t = localStorage.getItem(TOKEN_LS);
    if (t) h.Authorization = `Bearer ${t}`;
    const u = localStorage.getItem(UID_LS);
    if (u) h["X-User-Id"] = u;
  } catch { /* ignore */ }
  return h;
}

const http = axios.create({ baseURL: API, timeout: 25000 });
http.interceptors.request.use((c) => { c.headers = { ...(c.headers || {}), ...headers() }; return c; });

export const fxApi = {
  status:        () => http.get("/status"),
  account:       (mode = "demo") => http.get("/account", { params: { mode } }),
  instruments:   (mode = "demo") => http.get("/instruments", { params: { mode } }),
  instrumentList:() => http.get("/instruments/list"),
  quote:         (instrument, mode = "demo") => http.get("/quote", { params: { instrument, mode } }),
  chart:         (instrument, timeframe = "5M", count = 60, mode = "demo") =>
                   http.get("/chart", { params: { instrument, timeframe, count, mode } }),
  timeframes:    () => http.get("/timeframes"),
  orderStage:    (body) => http.post("/order/stage", body),
  intelligence:  (instrument, timeframe = "5M") =>
                   http.get(`/intelligence/${encodeURIComponent(instrument)}`, { params: { timeframe } }),
  intelligenceBoard: (timeframe = "5M") => http.get("/intelligence", { params: { timeframe } }),
  globalIntelligence: () => http.get("/global-intelligence"),
};

export const FX_DEFAULT_INSTRUMENT = "GBP_USD";
export const FX_TIMEFRAMES = ["2M", "5M", "10M", "15M", "1H", "1D"];
